import { action, makeObservable, observable } from 'mobx';

class CardsStore {
  tableCards = [];

  constructor() {
    makeObservable(this, {
      tableCards: observable.deep,
      setTableCards: action.bound,
      setWinInCards: action.bound,
      setWithOutWinCards: action.bound,
      closeCards: action.bound,
      removeWinInCards: action.bound,
    });
  }

  setWinInCards(cards) {
    this.tableCards = cards.map(({ index, isWin, ...all }) => ({
      isDisabled: !isWin,
      isWin,
      ...all,
    }));
  }

  removeWinInCards() {
    this.tableCards = this.tableCards.map(({ isWin, isDisabled, ...all }) => all);
  }

  setTableCards(payload) {
    this.tableCards = payload;
  }

  setWithOutWinCards(payload) {
    this.tableCards = payload.map(({ isWin, ...all }) => all);
  }

  closeCards() {
    this.tableCards = this.tableCards.map((item) => ({ close: true, ...item }));
  }
}

export const cardsStore = new CardsStore();
